import { useParams, useSearchParams } from 'next/navigation';

import { getPlaHeaders } from '../helpers/getPlaQueryParams';

import { useProductBySlugExtended } from './useProductBySlugExtended';

export function useProductBySlugExtendedPDP() {
  const { slug } = useParams<{ slug: string }>();

  // JR: 02/06/26: The following PLA headers are used to ensure consistent pricing between
  // PLA products and web PDP page. This is primarily for web crawlers to avoid Google
  // disapproving our PLA ads - international PLA products are not shown to
  // our users (i.e. US users -> UK prouct).

  // These query params are appended to urls within the product catalogues that the AdTech
  // team produce. If they do not exist then we should not pass these headers
  // within the http request. PR: https://github.com/depop/web-default-website-server/pull/4899.

  const searchParams = useSearchParams();
  const searchParamsRecord = searchParams
    ? Object.fromEntries(searchParams)
    : undefined;

  const headers = getPlaHeaders({ queryParams: searchParamsRecord });
  return useProductBySlugExtended(slug, headers);
}
